import moment, { Moment } from "moment";

/**
 * 根据小时数推演基于当前时间的时间点 <br>
 * 正数:向前推算时间（早于当前时间）<br>
 * 负数:向后推算时间（晚于当前时间）<br>
 */
export function calcTimeByHour(hours: number): string {

    return moment().subtract(hours, "hours").format("YYYY-MM-DD HH:mm:ss");
}

/**
 * 根据月份数推演基于当前时间的时间点 <br>
 * 正数:向前推算时间（早于当前时间）<br>
 * 负数:向后推算时间（晚于当前时间）<br>
 */
export function calcTimeByMonth(months: number): Moment {

    return moment().subtract(months, "months");
}

/**
 * 根据天数推演基于当前时间的时间点 <br>
 * 正数:向前推算时间（早于当前时间）<br>
 * 负数:向后推算时间（晚于当前时间）<br>
 */
 export function calcTimeByMonthWithDate(date:Moment,months: number): Moment {
    const cloneDate = moment(date.valueOf());   // 使用时间戳重新构造一个moment对象，防止改变date对象本身
    const d = cloneDate.subtract(months, "months");
    return d;
}

/**
 * 根据秒数推演基于当前时间的时间点 <br>
 * 正数:向前推算时间（早于当前时间）<br>
 * 负数:向后推算时间（晚于当前时间）<br>
 */
export function calcTimeBySecond(minutes: number): string {

    return moment().subtract(minutes, "seconds").format("YYYY-MM-DD HH:mm:ss");
}

/**
 * 根据天数推演基于当前时间的时间点 <br>
 * 正数:向前推算时间（早于当前时间）<br>
 * 负数:向后推算时间（晚于当前时间）<br>
 */
export function calcTimeByDay(days: number): string {

    return moment().subtract(days, "d").format("YYYY-MM-DD HH:mm:ss");
}


/**
 * 根据天数推演基于当前时间的时间点 <br>
 * 正数:向前推算时间（早于当前时间）<br>
 * 负数:向后推算时间（晚于当前时间）<br>
 */
export function calcTimeByDaysWithDate(date:Moment,days: number): string {

    return date.subtract(days, "d").format("YYYY-MM-DD HH:mm:ss");
}

/**
 * 获取当前时间(moment识别的日期格式掩码和java不太一样)
 */
export function getNowInStringFormat(): string {

    return moment().format("YYYY-MM-DD HH:mm:ss");
}

/**
 * 获取当前时间(moment识别的日期格式掩码和java不太一样)
 */
 export function getDayInStringFormat(): string {

    return moment().format("YYYY-MM-DD");
}

/**
 * 将字符串转化为日期
 */
 export function str2Day(day: string): Moment {

    return moment(day, "YYYY-MM-DD");
}

/**
 * 将字符串转化为日期时间
 */
export function str2Datetime(datetime: string): Moment {

    return moment(datetime, "YYYY-MM-DD HH:mm:ss");
}